<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
  <div class="row mb-2">
    <div class="col p-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pt-2">
          <div class="text-center text-danger">
            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
              details</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="row" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
  <div>
    <h5 class="mb-2 py-1 font-header-1">Import </h5>
  </div>
  <div class="col">
    <div class="card">

      <div class="card-header transparent d-flex justify-content-between align-items-center">
        <div class="input-group mb-3" style="width: 45%;">
          <input type="file" class="form-control" id="inputGroupFile02" (change)="onFileChanged($event.target.files)"
            [(ngModel)]="filepath">
          <div class="input-group-addon">
            <button class="btn btn-sm ms-2" [disabled]="IsButtonDisable || selectedFileName ==''||filepath == '' "
              (click)="onDOCFileChanged()" *ngIf="fp.importpaymentupload"><i class="fa fa-upload"
                aria-hidden="true"></i> </button>
          </div>
        </div>
        <span class="text_right"><button class="btn btn-sm" (click)="Refresh()">Refresh </button> </span>
      </div>

    </div>
  </div>
</div>
<div class="row mt-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
  <div class="col">
    <div class="card">
      <div class="card-body">
        <ejs-grid #grid [dataSource]='data | async' [allowResizing]='true' [allowSorting]='true'
          (resizeStop)="onResize($event)" [allowPaging]='true' [pageSettings]='initialPage'
          [filterSettings]='filterSettings' [allowFiltering]='true' (actionBegin)="onActionComplete($event)"
          [showColumnChooser]='true' allowTextWrap='true' [textWrapSettings]='wrapSettings'
          (dataStateChange)='dataStateChange($event)'>
          <e-columns>
            <e-column minWidth=30 uid="action" headerText="Action" [showInColumnChooser]='false'>
              <ng-template #template let-data>
                <button class="btn btn-edit-table text-center me-2" (click)="getclaimID(data.id)"><i
                    class="fa fa-download"></i></button>
                <button class="btn btn-edit-table text-center ms-2" (click)="ShowReport(data)"><i
                    class="fa fa-eye"></i></button>
              </ng-template>
            </e-column>
            <e-column minWidth=80 field="id" headerText="Import Id" type="number"></e-column>
            <e-column minWidth=100 field="fileName" headerText="File Name" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 field="importedDate" headerText="Import Date" type="date" [format]='formatOptions'>
            </e-column>

            <e-column minWidth=30 [showInColumnChooser]='false'>
              <ng-template #headerTemplate let-data>
                <div class="d-none d-lg-block">
                  <span id='show' (click)="show()"><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                </div>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </div>
</div>


<span id="openReportModal" data-bs-toggle="modal" data-bs-target="#viewReport"></span>
<div class="modal fade " id="viewReport" data-bs-backdrop="static">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Export Claims EDI-835</h5>
        <div class="text-right">
          <button class="btn blue-btn btn-sm mr-2" (click)="closemodal()">
            Close</button>
        </div>
      </div>
      <div class="modal-body" style="height:600px">
        <ng-container *ngIf="Reportcontain== true">
          <div style="width: 100%;height:100%" #reportContainer></div>
        </ng-container>
      </div>
    </div>
  </div>
</div>